import React from 'react';

import { createStyles } from '@mantine/core';
import { Outlet } from 'react-router-dom';

const useStyles = createStyles(theme => ({
  layout: {
    height: '100vh',
    width: '100%',
    overflowX: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    background: theme.white,

    '.page': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      maxWidth: '100%',
      flexGrow: 1,
      background: theme.white,

      '.header': {
        width: '100%',
        background: theme.white,
        padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
        display: 'grid',
        // `minmax(0, auto)` lets the center column shrink below its content width so a long
        // gym title truncates with an ellipsis; a plain `auto` track grows to fit and clips hard.
        gridTemplateColumns: '1fr minmax(0, auto) 1fr',
        gridTemplateRows: 'auto',
        alignItems: 'center',
        columnGap: theme.spacing.lg,

        '.logo': {
          gridRow: '1 / 2',
          gridColumn: '1 / 2',
        },

        '.titleWrapper': {
          gridRow: '1 / 2',
          gridColumn: '2 / 3',
          // grid items default to `min-width: auto` (won't shrink past content); reset so the
          // child Title's `truncate` (overflow/ellipsis) actually takes effect on mobile.
          minWidth: 0,
          overflow: 'hidden',
        },
      },

      '.content-home': {
        paddingTop: theme.spacing.md,
        paddingBottom: '3rem',
        paddingLeft: '4rem',
        paddingRight: '4rem',
        overflowY: 'auto',
        width: '100%',
        flexGrow: 1,
        [theme.fn.smallerThan('sm')]: {
          paddingLeft: '1rem',
          paddingRight: '1rem',
        },
      },

      '.content': {
        paddingTop: theme.spacing.md,
        paddingBottom: '3rem',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        overflowY: 'auto',
        width: '100%',
        maxWidth: 750,
        flexGrow: 1,
        background: theme.colors.gray[0],
        [theme.fn.smallerThan('sm')]: {
          paddingLeft: '1rem',
          paddingRight: '1rem',
        },
      },

      '.footer': {
        width: '100%',
        maxWidth: 750,
        background: theme.colors.gray[0],
        padding: theme.spacing.md,

        [theme.fn.smallerThan('sm')]: {
          minWidth: '70vw',
          width: '100%',
        },
      },
    },
  },
}));

const SalesPortalLayout = (): JSX.Element => {
  const { classes } = useStyles();

  return (
    <div className={classes.layout}>
      <div className='page'>
        <Outlet />
      </div>
    </div>
  );
};

export default SalesPortalLayout;
